<app-header></app-header>
<div class="row">
    <div class="col col-12">
       
        <div class="vincent_title_block vincent_corners">
            <div class="vincent_inner_text">
                <h1>{{"explore_lists" | translate}}</h1>
            </div>
        </div>
        
        <app-quickmenu></app-quickmenu>

        <app-contactsec></app-contactsec>

    </div>
</div>

<app-footer></app-footer>